import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from "./plugins/vuetify";
import mixins from './mixins/mixins';
import exporter from './export/exporter';
import setupInterceptor from './helpers/interceptor'
import '@mdi/font/css/materialdesignicons.css'

mixins; // We need to do this because of unused variable warnings

Vue.config.productionTip = false;
Vue.prototype.locale = window.navigator.language;

setupInterceptor();

new Vue({
    router,
    store,
    vuetify,
    exporter,
    render: h => h(App)
}).$mount('#app')
